<template>
  <div class="mainPart">
    <!--发货记录组件-->
    <!--S 检索-->
    <el-form inline :model="formInline">
      <el-form-item  label="销售单号">
        <el-input v-model.trim="formInline.saleorderno" placeholder="请输入销售单号" clearable></el-input>
      </el-form-item>
      <el-form-item label="订单号" class="codeSerIpt">
        <el-input v-model.trim="formInline.orderno" placeholder="请输入订单号" clearable></el-input>
      </el-form-item>
      <OrderState :excludeStates="excludeOrderStates" @orderStatusObtain="orderStatusReceive"></OrderState>
      <el-form-item label="手机号码">
        <el-input v-model.trim="formInline.receivertel" placeholder="请输入手机号码" clearable></el-input>
      </el-form-item>
      <el-form-item label="发货内容">
        <el-input v-model.trim="formInline.ordercontent" placeholder="请输入发货内容" clearable></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="search">查询</el-button>
      </el-form-item>
    </el-form>
    <!--E 检索-->

    <!--S 销售单列表-->
    <div class="allOrderTab individualiz">
      <el-form :model="formInline" inline size="medium">
        <!-- <el-form-item  class="borderline">
          <em class="greyColor">商品类型</em>
          <el-checkbox
            v-for="(item, index) of goodsTypeLists"
            v-model="item.checked"
            :label="item.label"
            :key="index"
            v-on:change="goodsTypeChange($event, item)"
          ></el-checkbox>
        </el-form-item> -->
        <el-form-item class="borderline borderNone">
          <em class="greyColor">绑卡状态</em>
          <el-checkbox
            v-for="(item, index) of cardBindSatus"
            v-model="item.checked"
            :label="item.label"
            :key="index"
            v-on:change="cardBindSatusChange($event, item)"
          ></el-checkbox>
        </el-form-item>
        <!-- <el-form-item class="borderline borderNone">
          <em class="greyColor">配送方式</em>
          <el-checkbox
            v-for="(item, index) of deliveryModeLists"
            v-model="item.checked"
            :label="item.label"
            :key="index"
            v-on:change="deliveryModeChange($event, item)"
          ></el-checkbox>
        </el-form-item> -->
      </el-form>
      <el-table
        v-loading="loading"
        :data="allOrderData"
        ref="orderTable"
        class="orderTable comTable"
        border
        :maxHeight="tableHeight"
      >
        <el-table-column type="index" label="序号" fixed></el-table-column>
        <el-table-column
          label="销售单号"
          prop="orderDate"
          sortable
          fixed
          min-width="200"
        >
          <template slot-scope="scope">
            <p class="textFl haveChildOd">{{scope.row.saleorderno}}</p>
            <!-- <small class="textFl" :title="scope.row.orderDate">{{scope.row.orderDate}}</small> -->
          </template>
        </el-table-column>
        <el-table-column
          label="订单号"
          prop="orderDate"
          sortable
          min-width="280"
        >
          <template slot-scope="scope">
            <p class="textFl haveChildOd">{{scope.row.orderno}}</p>
            <small
              class="textFl"
              :title="scope.row.submitdate  | dateFormate"
            >下单时间：{{scope.row.submitdate | dateFormate}}</small>
          </template>
        </el-table-column>
        <el-table-column label="状态" prop="orderStatus" sortable min-width="200">
          <template slot-scope="scope">
            <span
              :class="scope.row.ordstate | orderStateColorClass"
            >{{scope.row.ordstate | orderStateFilter}}</span>
            <b v-if="scope.row.goodstype == 1">/</b>
            <i
              v-if="scope.row.goodstype == 1"
              :class="scope.row.bindstatus ? 'blueColor' : 'orangeColor'"
            >{{scope.row.bindstatus ? '已绑卡' : '未绑卡'}}</i>
          </template>
        </el-table-column>
        <el-table-column label="发货内容" prop="orderPrice" sortable min-width="350">
          <template slot-scope="scope">
            <section class="pdr70">
              <div
                class="greyColor textFl"
                :title="scope.row.ordercontent"
              >{{scope.row.ordercontent}}</div>
              <p class="orderContentI">
                <em class="priceFont">
                  <em>￥</em>
                  {{scope.row.allamount | formatAmount}}
                </em>
                <!-- 商品类型 -->
                <i class="iconsw" title="实物商品" v-if="scope.row.goodstype == 0"></i>
                <i class="iconcard" title="礼品券卡" v-if="scope.row.goodstype==1"></i>
                <!-- 终端类型 -->
                <i
                  :class="{'iconpc':scope.row.terminaltype===0,'iconiPhone': scope.row.terminaltype===1,'iconwx':scope.row.terminaltype===2}"
                  :title="scope.row.terminaltype | terminalTypeFilter"
                ></i>
              </p>
            </section>
          </template>
        </el-table-column>
        <el-table-column label="配送方式" prop="deliveryMode" min-width="350">
          <template slot-scope="scope">
            <section class="pdr70">
              <div class="shouMsg">
                <strong
                  :class="[{'blueColor':scope.row.delimode == 1},{'orangeColor':scope.row.delimode == 0}]"
                >{{scope.row.delimode == 0 ? '自提' : '送货'}}</strong>
                <em v-if="scope.row.receivername">{{scope.row.receivername}}</em>
                <em v-if="scope.row.receivertel">{{scope.row.receivertel}}</em>
              </div>
              <p
                v-if="scope.row.delimode == 1"
                class="greyColor textFl"
                :title="scope.row.fulladdr"
              >{{scope.row.fulladdr | empty}}</p>
            </section>
          </template>
        </el-table-column>
        <el-table-column label="下单备注" prop="ordermemo" min-width="200">
          <template slot-scope="scope">
            <p
              class="textFl pdr70"
              :title="scope.row.ordermemo | empty"
            >{{scope.row.ordermemo | empty}}</p>
          </template>
        </el-table-column>
        <el-table-column label="操作" fixed="right" width="130">
          <template slot-scope="scope">
            <!--注意：总部这里只有查看详情操作-->
            <p class="handle">
              <span title="详情" @click="shipmentDetailBox(scope.row)">
                <i class="icondetails"></i>
              </span>
              <span
                v-if="scope.row.ordstate !== 8 && scope.row.goodstype == 1 && scope.row.bindstatus == 0 && scope.row.saleprosource === 1"
                title="绑卡"
                @click="bindCard(scope.row)"
              >
                <i class="iconlj"></i>
              </span>
              <span
                v-if="(scope.row.ordstate == 0 || scope.row.ordstate == 1) && scope.row.saleprosource === 1 && (scope.row.goodstype == 0 || (scope.row.goodstype === 1 && scope.row.bindstatus === 0))"
                title="取消订单"
                @click="cancelOrder(scope.row)"
              >
                <i class="iconjian"></i>
              </span>
            </p>
          </template>
        </el-table-column>
        <template slot="empty">
          <div class="noData">
            <span>暂无数据</span>
          </div>
        </template>
      </el-table>
    </div>
    <!--E 销售单列表-->
    <!-- S 分页 -->
    <Page
      :pageTotal="page.pagetotal"
      :currentPage="page.currentpage"
      :pageSize="page.pagesize"
      v-on:nowPageParam="nowPageParam"
    ></Page>
    <!-- S 分页 -->

    <!--S 发货详情弹窗-->
    <ShipDetail
      :shipmentDetail="shipmentDetailShow"
      :orderno="currentOrderItem ? currentOrderItem.orderno : ''"
      :saleorderno="currentOrderItem ? currentOrderItem.saleorderno : ''"
      :goodsType="goodsType"
      @closeShipDetail="closeShipBox"
    ></ShipDetail>
    <!--E 发货详情弹窗-->

    <!-- S 绑卡弹窗 -->
    <BindCardBox
      :bindCardShow="bindCardShow"
      :goodsType="goodsType"
      :orderno="currentOrderItem ? currentOrderItem.orderno : ''"
      :saleorderno="currentOrderItem ? currentOrderItem.saleorderno : ''"
      @closeBindCard="getCloseBindCardBox"
    ></BindCardBox>
    <!-- E 绑卡弹窗 -->

    <!--S 订单取消备注/修改备注组件-->
    <OrderMemo
      :orderMemoBox="orderMemo"
      :operateMemo="cancelEdit"
      :oldMemo="''"
      :operData="currentOrderItem"
      @closeVal="clsBtnVal"
      @closeOMemoBox="closeOrderMemo"
    ></OrderMemo>
    <!--E 订单取消备注/修改备注组件-->
  </div>
</template>
<script>
import { Message, MessageBox } from "element-ui";
import Api from "@/apis/api.js";
export default {
  name: "SalesOrderManage",
  data() {
    return {
      loading: true,
      excludeOrderStates: [],
      currentOrderItem: null,
      page: {
        pagetotal: 0,
        pagesize: 30,
        currentpage: 1,
        isnewcomp: 1,
        sortparam: null,
        sorttype: 0
      },
      // 订单绑卡列表
      cardBindSatus: [
        { label: "未绑卡", value: 0, checked: true },
        { label: "已绑卡", value: 1, checked: false }
      ],
      // 商品类型列表
      goodsTypeLists: [
        { label: "实物商品", value: 0, checked: false },
        { label: "礼品券卡", value: 1, checked: false }
      ],
      // 送货方式列表
      deliveryModeLists: [
        { label: "自提", value: 0, checked: false },
        { label: "送货", value: 1, checked: false }
      ],
      // 检索条件
      formInline: {
        delimode:0,
        // 订单号
        orderno: "",
        // 销售单号
        saleorderno: "",
        // 订单状态
        ordstate: "",
        // 手机号
        receivertel: "",
        //发货内容
        ordercontent: "",
        // 商品类型
        goodstype: 1,
        // 绑卡状态
        bindstatus:0,
        // 送货方式
        deliveryMode: null
      },
      // 全部订单数据
      allOrderData: [],
      tableHeight: window.innerHeight * 0.8, //表格动态高度
      shipmentDetailShow: false, //发货详情弹窗
      goodsType: 1, //商品类型，0：实物，1：券卡
      bindCardShow: false, //绑卡弹窗
      orderMemo: false, //取消订单备注弹窗
      btnVal: "", //取消订单备注按钮关闭还是确定
      cancelEdit: "cancel" //默认取消订单备注操作
    };
  },
  props: {
  },
  filters: {
    // 订单状态颜色区分
    orderStateColorClass: function(value) {
      return {
        greenColor: value >= 3 && value <= 5,
        orangeColor: value <= 1,
        greyColor: value === 7 || value === 8,
        blueColor: value === 6
      };
    }
  },
  components: {
    Page: resolve => require(["@/components/common/Page.vue"], resolve),
    ShipDetail: resolve =>
      require(["@/components/OrderFolder/StoreSale/ShipDetail.vue"], resolve),
    BindCardBox: resolve =>
      require(["@/components/OrderFolder/StoreSale/BindCardBox.vue"], resolve),
    OrderMemo: resolve =>
      require(["@/components/OrderFolder/OrderMemo.vue"], resolve),
    OrderState: resolve =>
      require(["@/components/Gadget/OrderState.vue"], resolve)
  },
  watch: {

  },
  methods: {
    search: function() {
      this.page.currentpage = 1;
      this.getOrderList();
    },
    deliveryModeChange: function(value, taget) {
      for (let item of this.deliveryModeLists) {
        if (item.checked && taget.value !== item.value) {
          item.checked = false;
          break;
        }
      }

      let delimodeCheced = this.deliveryModeLists.find(item => {
        return item.checked;
      });
      this.formInline.delimode = delimodeCheced ? delimodeCheced.value : null;

      this.page.currentpage = 1;
      this.getOrderList();
    },
    goodsTypeChange: function(value, taget) {
      for (let item of this.goodsTypeLists) {
        if (item.checked && taget.value !== item.value) {
          item.checked = false;
          break;
        }
      }

      let delimodeCheced = this.goodsTypeLists.find(item => {
        return item.checked;
      });
      this.formInline.goodstype = delimodeCheced ? delimodeCheced.value : null;

      this.page.currentpage = 1;
      this.getOrderList();
    },
    cardBindSatusChange: function(value, taget) {
      for (let item of this.cardBindSatus) {
        if (item.checked && taget.value !== item.value) {
          item.checked = false;
          break;
        }
      }

      let delimodeCheced = this.cardBindSatus.find(item => {
        return item.checked;
      });
      this.formInline.bindstatus = delimodeCheced ? delimodeCheced.value : null;

      this.page.currentpage = 1;
      this.getOrderList();
    },
    nowPageParam: function(pageSize, currentPage) {
      this.page.currentpage = currentPage;
      this.page.pagesize = pageSize;
      this.getOrderList();
    },
    // 订单状态下拉选择值
    orderStatusReceive(value) {
      this.formInline.ordstate = value;
    },
    getOrderList: function() {
      this.loading = true;
      let page = this.page;
      let param = {
        pageparam: {
          pagesize: page.pagesize,
          currentpage: page.currentpage,
          isnewcomp: page.isnewcomp,
          sortparam: page.sortparam,
          sorttype: page.sorttype
        }
      };
      Object.assign(param, this.formInline);
      Api.GET_ORDERLISTBYSALE(param)
        .then(res => {
          if (res.data.status === "200") {
            this.page.pagetotal = res.data.pagebean.totalnum;
            this.allOrderData = res.data.data;
          } else {
            this.allOrderData = [];
            Message.error({ message: res.data.message, offset: 200 });
          }
          this.loading = false;
        })
        .catch(res => {
          this.getTestData("getOrderList");
        });
    },
    // 查看发货详情
    shipmentDetailBox(row) {
      this.currentOrderItem = row;
      this.goodsType = row.goodstype;
      this.shipmentDetailShow = true;
    },
    // 关闭发货详情
    closeShipBox() {
      this.shipmentDetailShow = false;
    },
    // 绑卡弹窗
    bindCard(row) {
      this.currentOrderItem = row;
      this.goodsType = 1;
      this.bindCardShow = true;
    },
    // 关闭绑卡弹窗
    getCloseBindCardBox(val) {
      if (val == 1) {
        Message.success({ message: "提交成功！", offset: 200 });
        this.formInline.bindstatus=0;
        this.cardBindSatus[0].checked=true;
        this.getOrderList();
        this.bindCardShow = false;
      } else {
        this.bindCardShow = false;
      }
    },
    getSingleNum: function(orderno) {
      return new Promise((resolve, reject) => {
        Api.GET_SINGLENUM({ orderno: orderno })
          .then(res => {
            if (res.data.status === "200") {
              resolve(res.data);
            } else {
              reject(res.data);
            }
          })
          .catch(es => {
            reject({ message: "网络异常！", offset: 200 });
          });
      });
    },
    // 取消订单
    cancelOrder(row) {
      this.currentOrderItem = row;
      if (row.goodstype === 0) {
        this.getSingleNum(row.orderno)
          .then(res => {
            let datas = res.data;
            let num = datas.length;
            let stock = 0;
            datas.forEach(item => {
              stock += item.num;
            });
            MessageBox.confirm(
              `<p>确定取消订单<span class="plr5 orangeColor"> ${row.orderno} </span>吗？</p>`,
              "确认提示",
              {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                dangerouslyUseHTMLString: true,
                type: "warning"
              }
            ).then(() => {
              this.cancelEdit = "cancel";
              this.orderMemo = true;
            });
          })
          .catch(es => {
            Message.error({ message: es.message, offset: 200 });
          });
      } else if (row.goodstype === 1) {
        MessageBox.confirm(
          `<p>确定取消订单<span class="plr5 orangeColor"> ${row.orderno} </span>吗？</p>`,
          "确认提示",
          {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            dangerouslyUseHTMLString: true,
            type: "warning"
          }
        ).then(() => {
          this.cancelEdit = "cancel";
          this.orderMemo = true;
        });
      }
    },
    // 取消订单备注确定还是取消
    clsBtnVal(val) {
      this.btnVal = val;
    },
    // 确定取消订单备注
    closeOrderMemo(data) {
      this.orderMemo = false;
      if (data) {
        this.getOrderList();
      }
    },
    // 动态获取表格高度
    getHeight() {
      let tbHeight = this.$refs.orderTable.$el.offsetTop;
      this.tableHeight = window.innerHeight - tbHeight - 130;
    },
    getTestData: function(type) {}
  },
  created() {
    // 页面浏览器视窗变化绑定resize事件
    window.addEventListener("resize", this.getHeight);
  },
  mounted() {
    this.getOrderList();
      setTimeout(() => {
        this.getHeight();
      }, 200);
    
  },
  destroyed() {
    window.removeEventListener("resize", this.getHeight); //销毁监听浏览器视窗变化
  }
};
</script>

<style scoped>
@import "./Css/style.css";
.pdr70 {
  padding-right: 70px;
  width: auto;
}
</style>



// WEBPACK FOOTER //
// src/views/OrderFolder/StoreSale/HistoricalShipmentRecordsbk.vue